<header>
    <div class="mt-title">
        <img src="/assets/images/caamt_logo.jpg" alt="logo">
        <h3 class="">California Association for Music Therapy</h3>
    </div>
    <mt-main-nav></mt-main-nav>
</header>
